/* eslint-disable @typescript-eslint/no-explicit-any */
// Set of tools to send messages into the app webview

import { canUseDOM } from '@/app/common/utils/canUseDOM';

export type Features = {
  showLastminuteDeals?: boolean;
};
export const isWebView =
  canUseDOM && window && (window as any).ReactNativeWebView && (window as any).ReactNativeWebView.postMessage;

export const sendPlatformDataToApp = (platformData: object) => {
  if (!canUseDOM) return;
  if (isWebView) {
    const message = {
      eventType: '1SDP',
      platformData: [platformData],
    };
    (window as any).ReactNativeWebView.postMessage(JSON.stringify(message));
  }
};
